import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";
import { insightSegmentAll } from "@shared/constants/insight-segment.const";
import { InsightHttpService } from "@shared/http/insight-http.service";
import {
  FeatureInsightResponse,
  FeatureTrendResponse,
} from "@shared/models/feature-insight.model";
import { Observable, catchError, tap, throwError } from "rxjs";
import {
  GetFeatureInsight,
  GetFeatureTrend,
} from "../actions/feature-insight.action";
import { IFeatureInsightStateModel } from "../state-models/feature-insight-state.model";

@State<IFeatureInsightStateModel>({
  name: "featureInsightState",
  defaults: {
    featureInsight: {
      runAt: null,
      segment: insightSegmentAll,
      features: [],
    },
    featureTrend: null,
    loadFailed: false,
  },
})
@Injectable()
export class FeatureInsightState {
  constructor(private insightHttpService: InsightHttpService) {}

  @Action(GetFeatureInsight) getFeatureInsight(
    ctx: StateContext<IFeatureInsightStateModel>,
    { params }: GetFeatureInsight
  ): Observable<FeatureInsightResponse> {
    return this.insightHttpService.getFeatureInsight(params).pipe(
      tap((featureInsight) =>
        ctx.patchState({ featureInsight, loadFailed: false })
      ),
      // Rethrown so the global error interceptor still reports it; the flag only
      // lets the screen say "could not load" instead of "no data yet".
      catchError((error) => {
        ctx.patchState({ loadFailed: true });
        return throwError(() => error);
      })
    );
  }

  @Action(GetFeatureTrend) getFeatureTrend(
    ctx: StateContext<IFeatureInsightStateModel>,
    { params }: GetFeatureTrend
  ): Observable<FeatureTrendResponse> {
    return this.insightHttpService
      .getFeatureTrend(params)
      .pipe(tap((featureTrend) => ctx.patchState({ featureTrend })));
  }
}
